import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, unref as _unref } from "vue"
import _imports_0 from '@/assets/recharge/title.png'
import _imports_1 from '@/assets/recharge/icon-base.png'
import _imports_2 from '@/assets/recharge/icon-attendance.png'
import _imports_3 from '@/assets/recharge/hot-v2.png'
import _imports_4 from '@/assets/recharge/weixin-recharge-icon.png'
import _imports_5 from '@/assets/recharge/icon-attendance-flag.png'
import _imports_6 from '@/assets/recharge/icon-base-flag.png'
import _imports_7 from '@/assets/recharge/icon-seat.png'


const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "main-dialog" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = {
  key: 0,
  class: "tabs"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "none",
  version: "1.1",
  width: "371",
  height: "48",
  viewBox: "0 0 371 48",
  class: "tab__bg"
}
const _hoisted_8 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  fill: "none",
  version: "1.1",
  width: "371",
  height: "38",
  viewBox: "0 0 371 38",
  class: "tab__bg"
}
const _hoisted_9 = { class: "tab__content" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = {
  key: 0,
  class: "introduce"
}
const _hoisted_12 = { class: "name" }
const _hoisted_13 = {
  key: 0,
  src: _imports_1,
  class: "icon"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_2,
  class: "icon"
}
const _hoisted_15 = { class: "desc" }
const _hoisted_16 = { class: "interests" }
const _hoisted_17 = { class: "operation" }
const _hoisted_18 = {
  key: 1,
  class: "introduce-current"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "main" }
const _hoisted_22 = {
  key: 0,
  class: "recharge"
}
const _hoisted_23 = { class: "counter" }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = { class: "price" }
const _hoisted_26 = { class: "number" }
const _hoisted_27 = {
  key: 0,
  class: "original info-text"
}
const _hoisted_28 = { class: "desc info-text" }
const _hoisted_29 = {
  key: 1,
  class: "checkbox"
}
const _hoisted_30 = {
  key: 0,
  class: "separator"
}
const _hoisted_31 = {
  key: 1,
  class: "seat-box"
}
const _hoisted_32 = { class: "price" }
const _hoisted_33 = { class: "number" }
const _hoisted_34 = { class: "input-row" }
const _hoisted_35 = { class: "desc info-text" }
const _hoisted_36 = { class: "explain" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "explain-row" }
const _hoisted_39 = { class: "price" }
const _hoisted_40 = { class: "price-number" }
const _hoisted_41 = { class: "argeement" }
const _hoisted_42 = {
  key: 1,
  class: "comparison"
}
const _hoisted_43 = { class: "right" }
const _hoisted_44 = { class: "account" }
const _hoisted_45 = { class: "company" }
const _hoisted_46 = { class: "expire" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  src: _imports_5,
  class: "icon"
}
const _hoisted_50 = {
  key: 3,
  src: _imports_6,
  class: "icon"
}
const _hoisted_51 = {
  key: 0,
  class: "seat"
}
const _hoisted_52 = { class: "seat-row" }
const _hoisted_53 = { class: "seat-count" }
const _hoisted_54 = {
  key: 0,
  class: "due-date"
}
const _hoisted_55 = { class: "operation" }
const _hoisted_56 = { class: "pay-content" }
const _hoisted_57 = { class: "fc-orange bord" }

import store from '@/store'
import QRCode from 'qrcodejs2'
import { recharge } from '@/api/home'
import { computed, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { getCompanySeatInfo, CompanySeatInfoDto, SeatRecordDto } from '@/api/recharge-record'
import router from '@/router'
import { ElMessage } from 'element-plus'
import user from '@/utils/user'

enum ViewTypeEnum {
    Recharge = 'Recharge',
    Result = 'Result',
    Comparison = 'Comparison'
}

enum ProductTypeEnum {
    base = 'base',
    attendance = 'attendance'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'dialog-recharge',
  props: {
    show: {
        type: Boolean,
        default: false
    },
    noNeedRouter: Boolean
},
  emits: ['update:show', 'changeTab'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

let qrCode

const viewType = ref<ViewTypeEnum>(ViewTypeEnum.Recharge)
const account = ref({} as CompanySeatInfoDto)
const accountProductType = ref('')
const seatRecordList = ref({} as SeatRecordDto[])

const shopping = ref({
    productType: ProductTypeEnum.base,
    mainChecked: true,
    seatCount: 0,
    readArgeement: false
})

const wxPayVisible = ref(false)
const wxPayLoading = ref(false)

const productMap = ref({
    [ProductTypeEnum.base]: {
        name: '基础版',
        desc: '适用于人员稳定/小型企业使用',
        interests: [
            {
                label: '发薪席位·5个',
                lineHeight: true
            },
            {
                label: '员工考勤·不限人数'
            },
            {
                label: '工资条功能'
            },
            {
                label: '无限发布日结快招'
            },
            {
                label: '无限发薪项目数'
            },
            {
                label: '预支薪资权益'
            },
            {
                label: '私域员工简历库'
            }
        ],
        explain: [
            {
                label: '订购<span class="highlight">1年基础会员</span>包含<span class="highlight">5个</span>发薪席位，会员有效期内可享受相应权益。'
            }
        ],
        comparison: {
            price: '￥9.86/天',
            seat: '5个',
            attendance: true,
            attendancePrice: false,
            attendanceMachine: false,
            salary: true,
            fastRecruit: true,
            salaryProject: true,
            prepayment: true,
            resume: true
        },
        mainPrice: 3599,
        mainOriginalPrice: 6000,
        seatPrice: 300,
        mainPriceRequired: false,
        hasSeat: true,
        mainPriceDesc: '立省￥2491,低至￥9.86/天',
        seatPriceDesc: '会员含5个,超出部分￥300/位/年'
    },
    [ProductTypeEnum.attendance]: {
        name: '考勤版',
        desc: '适用于管理人员多/中大型企业',
        interests: [
            {
                label: '发薪席位·不限人数',
                lineHeight: true
            },
            {
                label: '员工考勤·不限人数'
            },
            {
                label: '考勤计工价·不限次数'
            },
            {
                label: '考勤机·30个',
                lineHeight: true
            },
            {
                label: '工资条功能'
            },
            {
                label: '无限发布日结快招'
            },
            {
                label: '无限发薪项目数'
            },
            {
                label: '预支薪资权益'
            },
            {
                label: '私域员工简历库'
            }
        ],
        explain: [
            {
                label: '订购<span class="highlight">1年专业版会员</span>包含<span class="highlight">不限</span>发薪席位、考勤机<span class="highlight">30个</span>，会员有效期内可享受相应权益。'
            }
        ],
        comparison: {
            price: '￥27.53/天',
            seat: '不限',
            attendance: true,
            attendancePrice: true,
            attendanceMachine: '30个',
            salary: true,
            fastRecruit: true,
            salaryProject: true,
            prepayment: true,
            resume: true
        },
        mainPrice: 9800,
        seatPrice: 0,
        mainOriginalPrice: 12800,
        mainPriceDesc: '立省￥3000,低至￥9.86/天',
        seatPriceDesc: '',
        hasSeat: false,
        mainPriceRequired: true
    }
})

const tabOptions = ref([
    {
        label: '基础版',
        value: ProductTypeEnum.base
    },
    {
        label: '考勤版',
        value: ProductTypeEnum.attendance
    }
])

const comparisonOptions = ref([
    {
        label: '价格',
        value: 'price'
    },
    {
        label: '发薪席位',
        value: 'seat'
    },
    {
        label: '基础考勤',
        value: 'attendance'
    },
    {
        label: '考勤计工价',
        value: 'attendancePrice'
    },
    {
        label: '考勤机',
        value: 'attendanceMachine'
    },
    {
        label: '工资条功能',
        value: 'salary'
    },
    {
        label: '日结快招',
        value: 'fastRecruit'
    },
    {
        label: '发薪项目数',
        value: 'salaryProject'
    },
    {
        label: '预支薪资',
        value: 'prepayment'
    },
    {
        label: '简历库',
        value: 'resume'
    },
    {
        label: '',
        value: 'operation'
    }
])

const activeProduct = computed(() => productMap.value[shopping.value.productType])

const nextExpireTime = computed(() => {
    const expireTime = account.value?.accountExpireTime ? dayjs(account.value?.accountExpireTime) : dayjs()
    return dayjs(expireTime).add(1, 'year').format('YYYY-MM-DD')
})

const isExpired = computed(() => {
    const expireTime = account.value?.accountExpireTime ? dayjs(account.value?.accountExpireTime) : dayjs()
    return expireTime.isBefore(dayjs())
})

const seatPrice = computed(() => {
    const seatCount = shopping.value.seatCount
    const seatPrice = activeProduct.value.seatPrice
    return seatCount * seatPrice
})

const totalPrice = computed(() => {
    const mainPrice = shopping.value.mainChecked ? activeProduct.value.mainPrice : 0
    return seatPrice.value + mainPrice
})

const visible = computed({
    get() {
        return props.show
    },
    set(val) {
        emits('update:show', val)
    }
})

watch(() => props.show, (val) => {
    if (val) {
        getAccountInfo()
    }
}, { immediate: true })

const avatar = computed(() => store.state.avatar)

user.waitLogin().then(() => {
    accountProductType.value = user.proFlag ? ProductTypeEnum.attendance : user.baseFlag ? ProductTypeEnum.base : ''
    shopping.value.productType = (accountProductType.value as ProductTypeEnum) || ProductTypeEnum.base
})

const getAccountInfo = async () => {
    const res = await getCompanySeatInfo({
        pageNum: 1,
        pageSize: 10
    })
    account.value = res || {} as CompanySeatInfoDto

    seatRecordList.value = res?.seatList?.list || [] as SeatRecordDto[]

    sessionStorage.setItem(
        'accountExpireTime',
        res?.accountExpireTime
    )
}

const onChangeViewType = (type: ViewTypeEnum) => {
    viewType.value = type
}

const onChangeProductType = (type: ProductTypeEnum) => {
    shopping.value.productType = type
    shopping.value.mainChecked = true
}

const onCheckMain = () => {
    if (activeProduct.value.mainPriceRequired) return false
    shopping.value.mainChecked = !shopping.value.mainChecked
}

const toRechargeRecord = () => {
    if (!props.noNeedRouter) {
        router.push({
            path: '/recharge/record',
            query: { tab: 'group' }
        })
    } else {
        emits('changeTab', 'group')
    }
    store.commit('changeRechargeTab', 'group-' + new Date().getTime())
    visible.value = false
}

const toService = () => {
    window.open(location.origin + '/#/agreement/serviceAgreement')
}

const toPrivate = () => {
    window.open(location.origin + '/#/agreement/privateAgreement')
}

const toRecharge = (productType) => {
    shopping.value.productType = productType || ProductTypeEnum.base
    viewType.value = ViewTypeEnum.Recharge
}

const onRecharge = async () => {
    if (!isExpired.value && accountProductType.value === ProductTypeEnum.attendance && shopping.value.productType === ProductTypeEnum.base) {
        ElMessage({
            type: 'warning',
            message: '您的团队版仍在有效期内，需等待当前版本到期后才能购买发薪版。'
        })
        return
    }
    if (
        (activeProduct.value.mainPriceRequired && !shopping.value.mainChecked) ||
        (!shopping.value.mainChecked && !shopping.value.seatCount)
    ) {
        ElMessage({
            type: 'warning',
            message: '请选择产品'
        })
        return
    }
    if (!shopping.value.readArgeement) {
        ElMessage({
            type: 'warning',
            message: '请阅读并同意服务协议'
        })
        return
    }
    wxPayVisible.value = true
    wxPayLoading.value = true
    setTimeout(() => {
        wxPayVisible.value = false
    }, 180000)
    const result = await recharge({
        amount: { total: totalPrice.value },
        total: totalPrice.value,
        description: shopping.value.productType === ProductTypeEnum.base ? '发薪版续费' : '发薪考勤版续费',
        mchid: 1720521610,
        useWay: 'AccountRecharge',
        attach: JSON.stringify({
            proFlag: shopping.value.productType === ProductTypeEnum.base ? 0 : 1,
            month: 12,
            paySeat: shopping.value.productType === ProductTypeEnum.base ? shopping.value.seatCount : undefined,
            salesScenario: getSalesScenario()
        })
    })
    await generateQRCode(result)
    wxPayLoading.value = false
}

/**
 * sales_scenario	bigint	销售场景 (
 *  0: 首签,
 *  1: 续签,
 *  2: 席位购买,
 *  3: 续费+席位购买,
 *  4: 首签+席位购买,
 *  5: 首签考勤版,
 *  6: 续签考勤版
 * )
 */
const getSalesScenario = () => {
    if (shopping.value.productType === ProductTypeEnum.base) {
        if (shopping.value.mainChecked && !shopping.value.seatCount) {
            return 1
        } else if (!shopping.value.mainChecked && shopping.value.seatCount) {
            return 2
        } else if (shopping.value.mainChecked && shopping.value.seatCount) {
            return 3
        }
    } else {
        return 6
    }
}

const getSeatTypeLabel = (seat: SeatRecordDto) => {
    const map = {
        1: '赠送席位',
        2: '席位购买'
    }
    return (map as any)[seat.salesScenario]
}

const generateQRCode = async (url: { codeUrl: string }) => {
    window.document.getElementById('code').innerHTML = ''
    qrCode = new QRCode('code', {
        text: url.codeUrl, // 二维码所携带的数据
        width: 170, // 二维码宽度
        height: 170 // 二维码高度
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_space = _resolveComponent("el-space")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_tempalte = _resolveComponent("tempalte")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
        width: "960px",
        "append-to-body": false
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "left" }, [
              _createElementVNode("div", { class: "title" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  class: "title-img"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              (viewType.value === ViewTypeEnum.Recharge)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabOptions.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(['tab', shopping.value.productType === item.value ? 'active' : '', item.value]),
                        onClick: ($event: any) => (onChangeProductType(item.value))
                      }, [
                        (shopping.value.productType === item.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[5] || (_cache[5] = [
                              _createElementVNode("g", null, [
                                _createElementVNode("path", {
                                  d: "M0.228561,48L371,48C366.118,48,361.677,45.1764,359.605,40.7559L346.982,13.8163C343.031,5.38523,334.56,0,325.249,0L46.6498,0C36.882,0,28.0886,5.91982,24.4135,14.9699L15.0528,38.0201C12.6027,44.0534,6.74044,48,0.228561,48Z",
                                  fill: "#FFFFFF",
                                  "fill-opacity": "1"
                                })
                              ], -1)
                            ])))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_8, _cache[6] || (_cache[6] = [
                              _createElementVNode("g", null, [
                                _createElementVNode("path", {
                                  d: "M3.66888,38L369.842,38C365.601,38,361.675,35.7617,359.515,32.1124L347.477,11.7751C343.157,4.4765,335.305,0,326.824,0L45.1549,0C36.1535,0,27.909,5.03683,23.8006,13.046L14.3461,31.477C12.2919,35.4816,8.16957,38,3.66888,38Z",
                                  fill: "#FEF4EC",
                                  "fill-opacity": "1"
                                })
                              ], -1)
                            ]))),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.label), 1)
                      ], 10, _hoisted_6))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([['content', shopping.value.productType], ""])
          }, [
            (viewType.value === ViewTypeEnum.Result)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_10, [
                    (viewType.value === ViewTypeEnum.Recharge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_space, null, {
                              default: _withCtx(() => [
                                (shopping.value.productType === ProductTypeEnum.base)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                                  : _createCommentVNode("", true),
                                (shopping.value.productType === ProductTypeEnum.attendance)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(activeProduct.value.name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(activeProduct.value.desc), 1),
                          _createElementVNode("div", _hoisted_16, [
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "interests-title" }, "套餐权益", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeProduct.value.interests, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: _normalizeClass(['interests-row', item.lineHeight ? 'highlight' : ''])
                              }, _toDisplayString(item.label), 3))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_el_button, {
                              link: "",
                              type: "text",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeViewType(ViewTypeEnum.Comparison)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_space, null, {
                                  default: _withCtx(() => [
                                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "查看权益对比详情", -1)),
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ArrowRightBold)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (viewType.value === ViewTypeEnum.Comparison)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "introduce-current-title" }, "当前套餐", -1)),
                          (!isExpired.value && accountProductType.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(productMap.value[accountProductType.value].name), 1)
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "name" }, "未开通会员", -1)),
                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "desc" }, "仅可使用投保功能", -1))
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (viewType.value === ViewTypeEnum.Recharge)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['main-checkbox', shopping.value.mainChecked && 'checked']),
                              style: _normalizeStyle(activeProduct.value.mainPriceRequired ? '' : 'cursor: pointer;'),
                              onClick: onCheckMain
                            }, [
                              _createElementVNode("div", _hoisted_24, _toDisplayString(activeProduct.value.name), 1),
                              _createElementVNode("div", _hoisted_25, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", null, "￥", -1)),
                                _createElementVNode("span", _hoisted_26, _toDisplayString(activeProduct.value.mainPrice), 1),
                                _cache[14] || (_cache[14] = _createElementVNode("span", null, "/年", -1))
                              ]),
                              (activeProduct.value.mainOriginalPrice !== activeProduct.value.mainPrice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, " ￥" + _toDisplayString(activeProduct.value.mainOriginalPrice), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_28, _toDisplayString(activeProduct.value.mainPriceDesc), 1),
                              _cache[15] || (_cache[15] = _createElementVNode("img", {
                                src: _imports_3,
                                alt: "",
                                class: "hot"
                              }, null, -1)),
                              (shopping.value.mainChecked)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _createVNode(_component_el_icon, { class: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Select)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ], 6),
                            (activeProduct.value.hasSeat)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createVNode(_component_el_icon, { size: 16 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (activeProduct.value.hasSeat)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "name" }, "选择购买席位数", -1)),
                                  _createElementVNode("div", _hoisted_32, [
                                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "￥", -1)),
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(seatPrice.value), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_el_input_number, {
                                      modelValue: shopping.value.seatCount,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shopping.value.seatCount) = $event)),
                                      min: 0,
                                      size: "mini"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_35, _toDisplayString(activeProduct.value.seatPriceDesc), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "explain-title" }, "选购详情：", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeProduct.value.explain, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "explain-row",
                                key: index,
                                innerHTML: item.label
                              }, null, 8, _hoisted_37))
                            }), 128)),
                            _createElementVNode("div", _hoisted_38, "会员有效期：" + _toDisplayString(nextExpireTime.value) + " 止", 1),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "explain-row" }, "付款审核成功后，立即生效", -1))
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "price-title" }, "订单金额：", -1)),
                            _cache[21] || (_cache[21] = _createElementVNode("span", { class: "price-prefix" }, "￥", -1)),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(totalPrice.value), 1)
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_el_checkbox, {
                              modelValue: shopping.value.readArgeement,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shopping.value.readArgeement) = $event))
                            }, {
                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createElementVNode("span", null, "我方已充分阅读并同意", -1)
                              ])),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_link, {
                              class: "fc-primary pointer",
                              onClick: _withModifiers(toService, ["stop"])
                            }, {
                              default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createTextVNode("《服务协议》")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_el_link, {
                              class: "fc-primary pointer",
                              onClick: _withModifiers(toPrivate, ["stop"])
                            }, {
                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                _createTextVNode("《隐私协议》")
                              ])),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_button, {
                              onClick: onRecharge,
                              class: "wxpay-button"
                            }, {
                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                _createElementVNode("div", { class: "button-inner" }, [
                                  _createElementVNode("img", {
                                    src: _imports_4,
                                    alt: "",
                                    class: "img"
                                  }),
                                  _createElementVNode("span", null, "微信扫码")
                                ], -1)
                              ])),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (viewType.value === ViewTypeEnum.Comparison)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _cache[28] || (_cache[28] = _createElementVNode("img", {
                            src: _imports_3,
                            alt: "",
                            class: "hot"
                          }, null, -1)),
                          _createVNode(_component_el_table, {
                            data: comparisonOptions.value,
                            size: "mini"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                prop: "label",
                                label: "版本",
                                width: "100"
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([ProductTypeEnum.base, ProductTypeEnum.attendance], (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: index,
                                  prop: item,
                                  label: productMap.value[item].name,
                                  width: "140",
                                  align: "center"
                                }, {
                                  header: _withCtx(({ column }) => [
                                    _createElementVNode("div", {
                                      style: _normalizeStyle({ fontWeight: 'bold', color: column.property === ProductTypeEnum.base ? '#1989FA' : '#A85F28' })
                                    }, _toDisplayString(productMap.value[column.property].name), 5)
                                  ]),
                                  default: _withCtx(({ row, column }) => [
                                    (row.value === 'operation')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (column.property === ProductTypeEnum.base)
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 0,
                                                class: "base-button",
                                                onClick: ($event: any) => (toRecharge(column.property))
                                              }, {
                                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                  _createTextVNode("立即购买")
                                                ])),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : (_openBlock(), _createBlock(_component_el_button, {
                                                key: 1,
                                                onClick: ($event: any) => (toRecharge(column.property)),
                                                class: "attendance-button"
                                              }, {
                                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                  _createTextVNode("立即升级")
                                                ])),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                        ], 64))
                                      : (typeof productMap.value[column.property].comparison[row.value] === 'string')
                                        ? (_openBlock(), _createBlock(_component_tempalte, { key: 1 }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                style: _normalizeStyle({ fontWeight: 'bold', color: column.property === ProductTypeEnum.base ? '#1989FA' : '#A85F28' })
                                              }, _toDisplayString(productMap.value[column.property].comparison[row.value]), 5)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                    (typeof productMap.value[column.property].comparison[row.value] === 'boolean')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          (productMap.value[column.property].comparison[row.value])
                                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 0,
                                                color: "#5E617D"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Select)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_el_icon, {
                                                key: 1,
                                                color: "#C0C0CE"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_CloseBold)
                                                ]),
                                                _: 1
                                              }))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["prop", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["data"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_el_scrollbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_avatar, {
                            size: 50,
                            src: avatar.value
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(account.value.companyName), 1),
                          _createElementVNode("div", _hoisted_46, [
                            (account.value.accountExpireTime)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(account.value.accountExpireTime) + "到期", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_48, "未开通会员")),
                            (!isExpired.value && accountProductType.value === ProductTypeEnum.attendance)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_49))
                              : _createCommentVNode("", true),
                            (!isExpired.value && accountProductType.value === ProductTypeEnum.base)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_50))
                              : _createCommentVNode("", true)
                          ]),
                          (accountProductType.value === ProductTypeEnum.base)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                _createElementVNode("div", _hoisted_52, [
                                  _cache[29] || (_cache[29] = _createElementVNode("img", {
                                    src: _imports_7,
                                    class: "icon"
                                  }, null, -1)),
                                  _createElementVNode("span", null, "当前共有席位数：" + _toDisplayString(account.value.hasSeat || 0), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seatRecordList.value, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: item.id,
                                    class: "seat-row"
                                  }, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("span", null, _toDisplayString(getSeatTypeLabel(item)) + "：", 1),
                                      _createElementVNode("span", _hoisted_53, _toDisplayString(item.salesScenario === 1 ? 5 :
                                                    item.buySeatCount), 1)
                                    ]),
                                    (item.seatExpirationTime)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(dayjs)(item.seatExpirationTime).format('YYYY-MM-DD')) + "到期", 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_el_button, { onClick: toRechargeRecord }, {
                              default: _withCtx(() => _cache[30] || (_cache[30] = [
                                _createTextVNode("开通记录")
                              ])),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ], 64))
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_dialog, {
      top: "20vh",
      modelValue: wxPayVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((wxPayVisible).value = $event)),
      width: "450px",
      title: "微信扫码支付",
      center: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _cache[32] || (_cache[32] = _createElementVNode("div", { claas: "img-border" }, [
            _createElementVNode("div", {
              id: "code",
              class: "code"
            })
          ], -1)),
          _createElementVNode("div", null, [
            _cache[31] || (_cache[31] = _createTextVNode("应付金额")),
            _createElementVNode("span", _hoisted_57, "¥" + _toDisplayString(totalPrice.value) + "元", 1)
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", null, [
            _createTextVNode("剩余支付时间"),
            _createElementVNode("span", { class: "fc-orange" }, "3分钟"),
            _createTextVNode("，否则订单将自动失效")
          ], -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})